// Initial-letters helper for the avatar fallback (US-182).
//
// Matches the prototype's "JD" pair-of-initials behaviour (lines 645) but
// safe against empty / single-word inputs. Email-derived fallback ensures
// a brand-new user without a `name` still gets a stable two-letter avatar.

export function deriveInitials(name?: string | null, emailFallback?: string | null): string {
  const trimmed = (name ?? '').trim();
  if (trimmed) {
    const tokens = trimmed.split(/\s+/u);
    if (tokens.length >= 2) {
      const first = tokens[0]?.[0] ?? '';
      const last = tokens[tokens.length - 1]?.[0] ?? '';
      return (first + last).toUpperCase();
    }
    if (tokens[0]) {
      return tokens[0].slice(0, 2).toUpperCase();
    }
  }
  const emailLocal = (emailFallback ?? '').split('@')[0] ?? '';
  if (emailLocal) {
    return emailLocal.slice(0, 2).toUpperCase();
  }
  return '··';
}
